import React, { memo } from "react";
import { Component } from "react";
import { authService } from "../../../auth";
import axios from "axios";
import { NavLink } from "react-router-dom";
class StudioTermsAndConditionPopUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
            checkedTermsAndCond: false,
            termsAndCondErrorMsg: ""
        }
    }

    handleStudioTermsAndCond = (event)=>{
        this.setState({checkedTermsAndCond: event.target.checked});
    };

    submitStudioTermsAndCond = () => {
        if(this.state.checkedTermsAndCond) {
            let postData = {
                "agreed": this.state.checkedTermsAndCond,
                "userId": this.props.userId
            };
            axios({
                method: 'POST',
                url: `${process.env.REACT_APP_userServiceURL}/StudioTermsAndCondition/create`,
                headers: { 'Content-Type': 'application/json' },
                data: postData,
                withCredentials: true
            }).then((response) => {
                if(response && response.data && response.data.message === "Success!") {
                    this.props.acceptStudioTermsAndCond();
                }
            }).catch((err) => {
    
            });
        } else {
            this.setState({
                termsAndCondErrorMsg: "Please accept the terms and conditions to proceed"
            })
            {
                setTimeout(() => {
                    this.setState({
                        termsAndCondErrorMsg: ""
                    });
                }, 5000);
            }
        }
    }

    componentWillUnmount() {
        window.$("#studioUserTermsCond").modal("hide");
    }

    componentDidMount() {
        if (this.props.editHelpDesk) {
            this.getHelpDeskDetailsById(this.props.editHelpDeskId);
        }
    }

    render() {
        const { checkedTermsAndCond, termsAndCondErrorMsg } = this.state;
        return (
            <div className="modal fade dgpopup reportPop" id="studioUserTermsCond" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop={'static'}>
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="forwcontwrap" style={{"position": "relative"}}>
                                <button type="button" className="close topCrossModal" data-dismiss="modal" aria-label="Close" onClick={() => this.props.history.goBack()}>
                                    <i className="iCross" /></button>
                                <div className="formwrap">
                                    <div className="custom-control custom-checkbox text-left">
                                        <input type="checkbox" className="custom-control-input"
                                            checked={checkedTermsAndCond}
                                            onChange={this.handleStudioTermsAndCond}
                                            id="projectFormVisibleToProfile" />
                                        <label className="custom-control-label"
                                            htmlFor="projectFormVisibleToProfile" style={{ cursor: 'pointer' }}>
                                            I accept the <NavLink to="/studio-terms-conditions" className="privacy-link" target="_blank">Terms & Conditions</NavLink> of Studio.
                                        </label>
                                    </div>
                                    {termsAndCondErrorMsg &&    <span className="login-feedback-error mt-1" style={{ display: "block" }}>{termsAndCondErrorMsg}</span>}
                                  </div>
                                <div className="formbottom text-center">
                                    <button type="button" className="btn btn-cancel" style={{ margin: '0' }}
                                        onClick={this.submitStudioTermsAndCond}>Agree & Proceed
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default memo(StudioTermsAndConditionPopUp);